import { Component } from "@angular/core";
import { Http, Response, Headers, RequestOptions } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { UserData, MandatoryFieldsContainer, RegistrationDataModel  } from "../../model/index";

@Component({
    providers: [Http]
})
export class RegistrationService {

    private _registrationTitleUrl = "api/RegistrationDetails/GetTitle";

    private _getMandatoryFieldsUrl = "api/RegistrationDetails/GetMandatoryFields";

    private _getNationalityUrl = "api/RegistrationDetails/GetNationality";

    private _getAreaUrl = "api/RegistrationDetails/GetAreaDataSet";

    private _getBloodGroupsUrl = "api/RegistrationDetails/GetBloodGroupDetails";

    private _getReligionDetailsUrl = "api/RegistrationDetails/GetReligionDetails";

    private _getRelationDetailsUrl = "api/RegistrationDetails/GetRelationDetails";

    private _getCaptchaVerification = "api/RegistrationDetails/CaptchaVerificationDetails";
    
    private _saveDetails = "api/RegistrationDetails/SaveDetails";

    private _alternateTypeDetails = "api/RegistrationDetails/GetAlternateTypeDetails";

    constructor(private _http: Http) {
    }
    
    public GetTitle(userId: string, authentication: string) {
        var userData: UserData = new UserData(userId, authentication, "", false);
        let headers: Headers = new Headers({ "Content-Type": "application/json" });
        var antiForgeryToken = $("input[name=__RequestVerificationToken]").val();
        headers.append("__RequestVerificationToken", antiForgeryToken);
        headers.append("MentisSoftAuthorization", "Basic " + btoa(userId + ":" + authentication));
        let options: RequestOptions = new RequestOptions({ headers: headers });

        let data$: Observable<MandatoryFieldsContainer> = this._http.post(this._registrationTitleUrl, "", options)
            .map(res => <MandatoryFieldsContainer>res.json())
            .catch(this.handleError);
        return data$;    
    }

    public GetMandatoryFields(userId: string, authentication: string, pLocationCode: string) {
        var userData: UserData = new UserData(userId, authentication, "", false);
        let headers: Headers = new Headers({ "Content-Type": "application/json" });
        var antiForgeryToken = $("input[name=__RequestVerificationToken]").val();
        headers.append("__RequestVerificationToken", antiForgeryToken);
        headers.append("MentisSoftAuthorization", "Basic " + btoa(userId + ":" + authentication));
        let options: RequestOptions = new RequestOptions({ headers: headers });
        let body = JSON.stringify(pLocationCode);
        let data$: Observable<MandatoryFieldsContainer> = this._http.post(this._getMandatoryFieldsUrl, body, options)
            .map(res => <MandatoryFieldsContainer>res.json())
            .catch(this.handleError);
        return data$;    
    }

    public GetNationality(userId: string, authentication: string) {
        var userData: UserData = new UserData(userId, authentication, "",false);
        let headers: Headers = new Headers({ "Content-Type": "application/json" });
        var antiForgeryToken = $("input[name=__RequestVerificationToken]").val();
        headers.append("__RequestVerificationToken", antiForgeryToken);
        headers.append("MentisSoftAuthorization", "Basic " + btoa(userId + ":" + authentication));
        let options: RequestOptions = new RequestOptions({ headers: headers });       
        let data$: Observable<MandatoryFieldsContainer> = this._http.post(this._getNationalityUrl, "", options)
            .map(res => <MandatoryFieldsContainer>res.json())
            .catch(this.handleError);
        return data$;
    }

    public GetAreaData(userId: string, authentication: string, areaCode: string, locationCode: string) {
        var userData: UserData = new UserData(userId, authentication, "",false);
        let headers: Headers = new Headers({ "Content-Type": "application/json" });
        var antiForgeryToken = $("input[name=__RequestVerificationToken]").val();
        headers.append("__RequestVerificationToken", antiForgeryToken);
        headers.append("MentisSoftAuthorization", "Basic " + btoa(userId + ":" + authentication));
        let options: RequestOptions = new RequestOptions({ headers: headers });
        let data = { "areaCode": areaCode, "locationCode": locationCode };
        let body = JSON.stringify(data);
        let data$: Observable<MandatoryFieldsContainer> = this._http.post(this._getAreaUrl, body, options)
            .map(res => <MandatoryFieldsContainer>res.json())
            .catch(this.handleError);
        return data$;
    }

    public GetBloodGroupDetails(userId: string, authentication: string) {
        var userData: UserData = new UserData(userId, authentication, "", false);
        let headers: Headers = new Headers({ "Content-Type": "application/json" });
        var antiForgeryToken = $("input[name=__RequestVerificationToken]").val();
        headers.append("__RequestVerificationToken", antiForgeryToken);
        headers.append("MentisSoftAuthorization", "Basic " + btoa(userId + ":" + authentication));
        let options: RequestOptions = new RequestOptions({ headers: headers });
        let data$: Observable<MandatoryFieldsContainer> = this._http.post(this._getBloodGroupsUrl, "", options)
            .map(res => <MandatoryFieldsContainer>res.json())
            .catch(this.handleError);
        return data$;
    }

    public GetRelationDetails(userId: string, authentication: string) {
        var userData: UserData = new UserData(userId, authentication, "",false);
        let headers: Headers = new Headers({ "Content-Type": "application/json" });
        var antiForgeryToken = $("input[name=__RequestVerificationToken]").val();
        headers.append("__RequestVerificationToken", antiForgeryToken);
        headers.append("MentisSoftAuthorization", "Basic " + btoa(userId + ":" + authentication));
        let options: RequestOptions = new RequestOptions({ headers: headers });
        let data$: Observable<MandatoryFieldsContainer> = this._http.post(this._getRelationDetailsUrl, "", options)
            .map(res => <MandatoryFieldsContainer>res.json())
            .catch(this.handleError);
        return data$;
    }

    public GetReligionDetails(userId: string, authentication: string, pLocationCode: string) {
        var userData: UserData = new UserData(userId, authentication, "",false);
        let headers: Headers = new Headers({ "Content-Type": "application/json" });
        var antiForgeryToken = $("input[name=__RequestVerificationToken]").val();
        headers.append("__RequestVerificationToken", antiForgeryToken);
        headers.append("MentisSoftAuthorization", "Basic " + btoa(userId + ":" + authentication));
        let options: RequestOptions = new RequestOptions({ headers: headers });
        let body = JSON.stringify(pLocationCode);
        let data$: Observable<MandatoryFieldsContainer> = this._http.post(this._getReligionDetailsUrl, body, options)
            .map(res => <MandatoryFieldsContainer>res.json())
            .catch(this.handleError);
        return data$;
    }

    public GetAlternateTypeDetails(userId: string, authentication: string) {
        var userData: UserData = new UserData(userId, authentication, "",false);
        let headers: Headers = new Headers({ "Content-Type": "application/json" });
        var antiForgeryToken = $("input[name=__RequestVerificationToken]").val();
        headers.append("__RequestVerificationToken", antiForgeryToken);
        headers.append("MentisSoftAuthorization", "Basic " + btoa(userId + ":" + authentication));
        let options: RequestOptions = new RequestOptions({ headers: headers });      
        let data$ : Observable<MandatoryFieldsContainer> = this._http.post(this._alternateTypeDetails, "", options)
            .map(res => <MandatoryFieldsContainer>res.json())
            .catch(this.handleError);
        return data$;
    }

    public CaptchaVerification(userId: string, authentication: string, value: string) {
        var userData: UserData = new UserData(userId, authentication, "",false);
        let headers: Headers = new Headers({ "Content-Type": "application/json" });
        var antiForgeryToken = $("input[name=__RequestVerificationToken]").val();
        headers.append("__RequestVerificationToken", antiForgeryToken);
        headers.append("MentisSoftAuthorization", "Basic " + btoa(userId + ":" + authentication));
        let options: RequestOptions = new RequestOptions({ headers: headers });
        let body = JSON.stringify(value);
        let data$ = this._http.post(this._getCaptchaVerification, body, options)
            .map(res => res.json())
            .catch(this.handleError);
        return data$;
    } 

    public SaveDetails(registrationDataModel:RegistrationDataModel) {
       
        let body: string = JSON.stringify(registrationDataModel);
        let headers: Headers = new Headers({ "Content-Type": "application/json" });
        var antiForgeryToken = $("input[name=__RequestVerificationToken]").val();
        headers.append("__RequestVerificationToken", antiForgeryToken);
        headers.append("MentisSoftAuthorization", "Basic " + btoa("" + "" + ""));
        let options: RequestOptions = new RequestOptions({ headers: headers });

        let data$ = this._http.post(this._saveDetails, body, options)
            .map(res => res.json())
            .catch(this.handleError);
        return data$;
    }

    private handleError(error: Response | any) {
        let errMsg: string;
        if (error instanceof Response) {
            const body = error.json() || "";
            const err = body.error || JSON.stringify(body);
            errMsg = `${error.status} - ${error.statusText || ""} ${err}`;
        } else {
            errMsg = error.message ? error.message : error.toString();
        }
        return Observable.throw(errMsg || " API Server Error");
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/Register/Service/Registration.Service.ts